import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { formBase, isSubmitted, submitExerciseForm } from '../../../modules/ExerciseForm';
import SortableTable from '../../../components/molecule/SortableTable'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 65%;
`
const SortableTableStyled  = styled(SortableTable)`
  width: 100%;
`
const FormStyled = styled(Form)`
  display: flex;
`

class ClassesCreateForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
    }
  }

  // componentWillUnmount() {
  //   this.props.submitForm();
  // }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  render () {
    const {
      values,
    } = this.props;
    return (
      <FormStyled>
        <Container>
          <SortableTableStyled
            onChange={(val) => this.changeTracker(val,'sets')}
            value={values.sets}
            validate
          />
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    exerciseFormState: state.exerciseFormState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    formBase: formBase,
    isSubmitted: isSubmitted,
    submitExerciseForm: submitExerciseForm,
  }, dispatch)
}

export default compose(connect(mapStateToProps,mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
  }),

  validate: (values, props) => {
    props.submit(values);
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
}))(ClassesCreateForm);
